<!-- Filter - Search - Form  -->
<div class="data-action-form">
  <div class="row justify-content-between align-items-center">
    <div class="col-12 col-sm-12 col-md-7 col-lg-6 col-xl-5">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0);" routerLink="/owner_info" routerLinkActive="active">Owner Info</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ ownerName }}</li>
        </ol>
      </nav>
    </div>
    <div class="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-7">
      <div class="text-left text-md-right">
        <a href="javascript:void(0);" routerLink="/owner_info" routerLinkActive="active" class="btn btn-dark mb-3 mr-2"
          >Cancel</a
        >
        <button
          type="submit"
          class="btn btn-success mb-3"
          (click)="submitOwnerInfo(ownerInfoForm, ownerInfoForm.value.facility_)">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div class="card">
  <div class="card-header font-weight-bold">Owner Details</div>
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="form-group">
          <label>Owner</label>
          <input
            type="text"
            class="form-control"
            name="ownerName"
            [(ngModel)]="ownerName"
            placeholder="Access Business Group"
            tabindex="1" />
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-3">
        <div class="form-group">
          <label>Project Industry</label>
          <select
            class="form-control select2"
            tabindex="9"
            [(ngModel)]="projectIndustryType"
            #project_industry_id
            id="project_industry_id">
            <option value="">Select Project Industry</option>
            <option *ngFor="let item of projectIndustryData" value="{{ item.id }}">
              {{ item.name }}
            </option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input
              type="text"
              [(ngModel)]="projectIndustryType"
              id="project_industry_id"
              (blur)="setProjectIndustryData(project_industry_id.value)" />
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="ownerInfoForm">
      <ng-container formArrayName="facility_">
        <div class="border p-3 mt-2">
          <div *ngFor="let ctrl of ownerInfoForm.get('facility_')['controls']; let i = index" [formGroupName]="i">
            <div formArrayName="indifacility">
              <div
                *ngFor="let individualfacility of ctrl.get('indifacility')['controls']; let j = index"
                [formGroupName]="j">
                <input type="hidden" formControlName="id" id="facility_id_{{ j }}" />
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8 col-lg-9 order-sm-12">
                    <div class="text-right">
                      <button
                        *ngIf="individualfacility?.value?.id"
                        (click)="assignCertificates(individualfacility.value)"
                        class="btn btn-primary mr-2"
                        data-toggle="modal"
                        data-target="#certsAssignmentModal">
                        Assign Certificates
                      </button>
                      <a
                        href="javascript:void(0);"
                        class="text-primary mr-2 font-20"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Duplicate"
                        (click)="
                          addAdditionalInfoSameEditTime(ctrl.get('indifacility'), individualfacility.value, true)
                        "
                        ><i class="far fa-clone"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="text-danger font-20"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Delete"
                        ><i class="far fa-trash" (click)="deleteFacility(ctrl, individualfacility.value.id, i, j)"></i
                      ></a>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 order-sm-1">
                    <div class="form-group">
                      <label>Facility/Location</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="facility_name"
                        id="facility_name_{{ j }}"
                        placeholder="Facility/Location"
                        tabindex="{{ 2 + 6 * j }}" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl">
                    <div class="form-group">
                      <label>Street Address / P.O. Box *</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="street_address"
                        id="street_address_{{ j }}"
                        placeholder="Street Address / P.O. Box"
                        tabindex="{{ 2 + 6 * j + 1 }}" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl">
                    <div class="form-group">
                      <label>Apartment, suite, unit, floor, etc</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="apartment"
                        id="apartment_{{ j }}"
                        placeholder="Apartment, suite, unit, floor, etc"
                        tabindex="{{ 2 + 6 * j + 2 }}" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>City *</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="city"
                        id="city_{{ j }}"
                        placeholder="City"
                        tabindex="{{ 2 + 6 * j + 3 }}" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>State *</label>
                      <select
                        class="form-control select2"
                        formControlName="state"
                        #state
                        id="state_{{ j }}"
                        tabindex="{{ 2 + 6 * j + 4 }}">
                        <option disabled="" selected="">State</option>
                        <option *ngFor="let item of statesData" value="{{ item.id }}">
                          {{ item.abbreviation }}
                        </option>
                      </select>
                      <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                        <input
                          type="text"
                          formControlName="state"
                          id="state"
                          (blur)="setDataToGroupControl(individualfacility, 'state', state.value)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl">
                    <div class="form-group">
                      <label>Zipcode *</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="zipcode"
                        id="zipcode_{{ j }}"
                        placeholder="Zipcode"
                        tabindex="{{ 2 + 6 * j + 5 }}" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-1">
                    <div class="form-group">
                      <label>Code</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="code"
                        id="code_{{ j }}"
                        placeholder="Code"
                        tabindex="{{ 2 + 6 * j + 6 }}"
                        maxlength="2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <a
                href="javascript:void(0);"
                class="text-primary font-weight-bold"
                (click)="addAdditionalInfoSameEditTime(ctrl.get('indifacility'))"
                tabindex="100"
                >+ Add Facility</a
              >
            </div>
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</div>

<!-- Certificate Assignment Modal -->
<div
  class="modal fade"
  id="certsAssignmentModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="certsAssignmentModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center" id="certsAssignmentModalLabel">
          {{ facilityCerts?.facility?.facility_name }} Certificates/Attributes
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <input (input)="searchCerts($event)" class="form-control float-right" type="search" placeholder="Search Certs" />
      <div class="modal-body">
         <!-- Apply to all Facilities Checkbox -->
        <div class="row mb-2">
          <div class="col-12">
            <div class="d-flex align-items-center">
              <input type="checkbox" class="input-checkbox mr-2" id="allFacilities" [(ngModel)]="applyToAll">
              <label class="attribute-certification-text font-weight-bold h4 m-0" for="allFacilities">Apply to all Facilities</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div
              *ngFor="let cert of certificates.slice(0, certificates.length / 2) | paginate: 10 : certsPage"
              class="row">
              <div class="col-12">
                <input
                  #status
                  type="checkbox"
                  (change)="setCertStatus(cert, status.checked)"
                  [ngModel]="getMatchingAttr(cert)?.status"
                  class="input-checkbox mr-2"
                  [id]="cert.id" />
                <label class="attribute-certification-text m-0" [for]="cert.id">{{ cert.name }}</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              *ngFor="let cert of certificates.slice(certificates.length / 2) | paginate: 10 : certsPage"
              class="row">
              <div class="col-12">
                <input
                  #status
                  type="checkbox"
                  (change)="setCertStatus(cert, status.checked)"
                  [ngModel]="getMatchingAttr(cert)?.status"
                  class="input-checkbox mr-2"
                  [id]="cert.id" />
                <label class="attribute-certification-text m-0" [for]="cert.id">{{ cert.name }}</label>
              </div>
            </div>
          </div>
        </div>
        <i style="cursor: pointer" class="fa fa-arrow-alt-left" *ngIf="certsPage > 0" (click)="pageCerts(-1)"></i>
        <i
          style="cursor: pointer"
          class="fa fa-arrow-alt-right float-right"
          *ngIf="(certificates.slice(certificates.length / 2) | paginate: 10 : certsPage + 1)?.length > 0"
          (click)="pageCerts(1)"></i>
      </div>
      <div class="modal-footer pb-3">
         <button (click)="saveCerts(applyToAll)" type="button" class="btn btn-success">Save changes</button>
        <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
